module.exports = __webpack_public_path__ + "static/media/back.69695359.svg";